import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Draggable from 'react-draggable';
import './TextToImage.css';
import ImageComponent from './components/image-component/ImageComponent';
import {
  toggleIsActive,
  changeTextProperty,
} from './../../redux/actions/entities/texts';
import { disableImageMove } from './../../helpers/textHelper';

class TextToImage extends Component {
  constructor(props) {
    super(props);
    this.textTarget = '';
    this.imageRef = '';
  }


  componentDidUpdate(prevProps) {
    const {
      dragWrapper,
      images,
      pageRatio,
      id,
      isOverflow,
      style,
      isSpineText,
      spineRef,
    } = this.props;

    const { images: prevImages, style: prevStyle } = prevProps;


    // Check overflow image / text
    const { thumbnail } = images;
    const { thumbnail: prevThumbnail } = prevImages;

    if (thumbnail.width !== prevThumbnail.width || style.x !== prevStyle.x) {
      // Promise?
      setTimeout(() => {
        if (this.imageRef) {
          const { left } = this.imageRef.getBoundingClientRect();
          const {
            left: wrapperLeft,
            width: wrapperWidht,
          } = dragWrapper.getBoundingClientRect();
          const imagePosition = Math.round((left - wrapperLeft) + (thumbnail.width / pageRatio));

          // Spine
          if (isSpineText) {
            const { height } = spineRef.getBoundingClientRect();
            const { clientWidth } = spineRef.children[0].children[0];

            if ((clientWidth + 90) > height) {
              this.props.dispatch(changeTextProperty(id, 'isOverflow', true));
            } else if (isOverflow) {
              this.props.dispatch(changeTextProperty(id, 'isOverflow', false));
            }
            return;
          }
          // Text-wrapper
          if (Math.round(imagePosition) > Math.round(wrapperWidht)) {
            this.props.dispatch(changeTextProperty(id, 'isOverflow', true));
          } else if (isOverflow) {
            this.props.dispatch(changeTextProperty(id, 'isOverflow', false));
          }
        }
      }, 200);
    }
  }


  setActive = (event) => {
    const targetId = event.target.getAttribute('data-id');

    if (targetId) {
      this.props.dispatch(toggleIsActive(parseInt(targetId, 10)));
    }
  }

  getCoverCoords = () => {
    const { dragWrapper, layerRef } = this.props;
    const coverCoordX = dragWrapper.getBoundingClientRect().left - layerRef.getBoundingClientRect().left;
    const coverCoordY = dragWrapper.getBoundingClientRect().top - layerRef.getBoundingClientRect().top;

    return {
      x: coverCoordX,
      y: coverCoordY,
    };
  }

  activeText = () => {
    const { texts } = this.props;
    return Object.values(texts).find(element => element.isActive);
  }


  render() {
    const {
      id,
      images,
      texts,
      isActive,
      marginLimit,
      pageRatio,
      isSpineText,
      imageWidth,
      isPhotoCover,
    } = this.props;


    const { positions } = texts[id];

    let editorTextPosition = {
      x: (positions.x - (marginLimit * pageRatio)) / pageRatio,
      y: (positions.y - (marginLimit * pageRatio)) / pageRatio,
    };
    if (isPhotoCover) {
      // Recalculate cover layout position
      editorTextPosition = {
        x: -this.getCoverCoords().x + (positions.x / pageRatio),
        y: -this.getCoverCoords().y + (positions.y / pageRatio),
      };
    }

    const wrapperStyle = {
      width: imageWidth / pageRatio,
    };

    const fiveMM = 59;
    const imageSize = fiveMM / pageRatio;
    const imageStyle = {
      height: isSpineText ? `${imageSize}px` : 'initial',
    };

    return (
      <Draggable
        bounds="parent"
        handle=".text-wrapper"

        enableUserSelectHack={false}
        position={editorTextPosition}
        disabled
      >
        <div
          className={`text-wrapper ${isActive ? 'active' : ''} ${isSpineText ? 'coverText' : ''} `}
          ref={(textTarget) => { this.textTarget = textTarget; }}
          onKeyPress={() => {}}
          onClick={(event) => { this.setActive(event); }}
          role="button"
          tabIndex="-4"
          data-id={id}
          style={!isSpineText ? wrapperStyle : ''}
        >
          { images !== undefined &&
            <ImageComponent
              image={images.thumbnail.relativeURl}
              pageRatio={pageRatio}
              imageRef={(imageRef) => { this.imageRef = imageRef; }}
              style={imageStyle}
            />
          }

        </div>
      </Draggable>
    );
  }
}

TextToImage.defaultProps = {
  id: 0,
  images: {
    thumbnail: '',
    full: '',
  },
  texts: {},
  marginLimit: 0,
  pageRatio: 1,
  isActive: false,
  isSpineText: false,
  imageWidth: 0,
  isPhotoCover: false,
  style: {},
  dragWrapper: {},
  layerRef: {},
  isOverflow: false,
  isMoveable: true,
};

TextToImage.propTypes = {
  id: PropTypes.number,
  images: PropTypes.object,
  texts: PropTypes.object,
  isActive: PropTypes.bool,
  pageRatio: PropTypes.number,
  marginLimit: PropTypes.number,
  isSpineText: PropTypes.bool,
  imageWidth: PropTypes.number,
  isPhotoCover: PropTypes.bool,
  style: PropTypes.object,
  dragWrapper: PropTypes.object,
  layerRef: PropTypes.object,
  isOverflow: PropTypes.bool,
  isMoveable: PropTypes.bool,
};

export default connect(state => ({
  texts: state.entities.texts,
}))(TextToImage);




// WEBPACK FOOTER //
// ./src/components/text-to-image/TextToImage.jsx